import { render, staticRenderFns } from "./NeoparentFeedback.vue?vue&type=template&id=267e0809&scoped=true"
import script from "./NeoparentFeedback.vue?vue&type=script&lang=js"
export * from "./NeoparentFeedback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "267e0809",
  null
  
)

export default component.exports